import type { DataObject } from '@/api/objects';
import { StatusBadge } from '@/components/StatusBadge';

export function ObjectStatusBadge({ object }: { object: Pick<DataObject, 'client_status'> }) {
  return <StatusBadge status={object.client_status} scope="object" />;
}
